import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteKubernetesScopedKubeconfig } from '@api/sdk.gen';

import { withError } from '@/react-tools/react-query';
import { promiseSequence } from '@/portainer/helpers/promise-utils';

import { ScopedKubeconfig } from '../types';

import { queryKeys } from './query-keys';

/**
 * Revoking is per environment, so a selection spanning environments is revoked
 * one call at a time against the environment each record belongs to.
 */
export function useRevokeScopedKubeconfigsMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (scopedKubeconfigs: ScopedKubeconfig[]) =>
      promiseSequence(
        scopedKubeconfigs.map(
          (scopedKubeconfig) => () => revoke(scopedKubeconfig)
        )
      ),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: queryKeys.base() }),
    ...withError('Unable to revoke scoped kubeconfig(s)'),
  });
}

async function revoke(scopedKubeconfig: ScopedKubeconfig) {
  await deleteKubernetesScopedKubeconfig({
    path: {
      id: scopedKubeconfig.endpointId ?? 0,
      scopedKubeconfigId: scopedKubeconfig.id ?? 0,
    },
  });
}
